import { render, staticRenderFns } from "./AdvancedLearning.vue?vue&type=template&id=094228fa&scoped=true"
import script from "./AdvancedLearning.vue?vue&type=script&lang=js"
export * from "./AdvancedLearning.vue?vue&type=script&lang=js"
import style0 from "./AdvancedLearning.vue?vue&type=style&index=0&id=094228fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094228fa",
  null
  
)

export default component.exports